module.exports = __webpack_public_path__ + "static/media/logo-inputs.1e395f07.jpg";